import type { SerializeOptions } from './serializeOptions';
import { serializeParagraph } from './serializeParagraph';
import { serializeTable } from './serializeTable';
import type { CastBlockContent, CastPrimaryStyle } from '../types';

export function serializeBlock(
  block: CastBlockContent,
  options: SerializeOptions,
  sectionStyle?: CastPrimaryStyle
): string | null {
  switch (block.type) {
    case 'paragraph':
      return serializeParagraph(block, options, sectionStyle);
    case 'table':
      return serializeTable(block, options, serializeBlock, sectionStyle);
  }
}
